import { connect } from 'react-redux';

import { fetchNlpTranscript } from 'api/nlp/nlp.actions';
import { NlpTranscriptTable } from './NlpTranscriptTable';

const mapDispatchToProps = (dispatch: Function) => ({
  fetchNlpTranscript: (eventId: string) => dispatch(fetchNlpTranscript(eventId)),
});

export const NlpTranscriptTableContainer = connect(null, mapDispatchToProps)(NlpTranscriptTable);
